import state from './state';
import mutations from './mutations';
import { Module } from 'vuex';
import { GlobalStateShape, RootStateShape } from 'store';

export default { namespaced: true, state, mutations } as Module<GlobalStateShape, RootStateShape>;
